import React from 'react';
import { OnboardingStep } from '../onboarding.types';

export const PREVIEW_TOUR: OnboardingStep[] = [
    {
        title: 'Preview',
        placement: 'center',
        content: (
            <>
                Almost there.
                <br />
                Now carefully review the product that we&#39;ve been just
                creating. Save when ready
            </>
        ),
    },
];
